<div class="toast-container">

    @for (toast of toastService.toasts(); track toast.id) {

    <div class="toast" [class.toast-success]="toast.type === 'success'" [class.toast-info]="toast.type === 'info'"
        [class.toast-warning]="toast.type === 'warning'" [class.toast-error]="toast.type === 'error'">

        <button type="button" class="toast-close" aria-label="Toast schließen" (click)="remove(toast)">
            ✕
        </button>

        <strong>
            {{ toast.title }}
        </strong>

        @if (toast.message) {
        <span>
            {{ toast.message }}
        </span>
        }

        @if (toast.actions?.length) {
        <div class="toast-actions">
            @for (action of toast.actions; track action.label) {
            <button type="button" class="toast-action" [class.toast-action-primary]="action.variant === 'primary'"
                [class.toast-action-secondary]="action.variant !== 'primary'" (click)="runAction(toast, action)">
                {{ action.label }}
            </button>
            }
        </div>
        }

    </div>

    }

</div>